import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { StoreType } from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Delimiter,
    LinkButton,

    PrepareNestedHistory,
    NestedHistory,
    HistoryList,
} from "client/components"

const History = () => {
    const history = useSelector((state: StoreType) => state.ccReviewCompliance.itemHistory)
    const tempAnswerHistory = useSelector((state: StoreType) => state.ccReviewCompliance.tempAnswerHistory)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [hidePrev, setHidePrev] = useState(true)
    const [nestedHistory, setNestedHistory] = useState<NestedHistory[]>([])

    useEffect(() => {
        const newHistory = tempAnswerHistory ? [...history, tempAnswerHistory] : history
        const nested = PrepareNestedHistory(newHistory)
        setNestedHistory(nested)
    }, [history, tempAnswerHistory])

    const showHideHistory = () => {
        setHidePrev(!hidePrev)
    }

    return (
        <PageForm noPaddingTop>
            <Row>
                <Col xs={12}>
                    <Delimiter />
                    <FormGroup>
                        <Label>{lang.history}</Label>
                    </FormGroup>

                    {
                        nestedHistory.length > 1 && (
                            <p>
                                <LinkButton onClick={showHideHistory}>
                                    {hidePrev ? lang.showPrevious : lang.hidePrevious}
                                </LinkButton>
                            </p>
                        )
                    }

                    <HistoryList nested={hidePrev && nestedHistory.length > 1
                        ? [nestedHistory[nestedHistory.length - 1]]
                        : nestedHistory}
                    />
                </Col>
            </Row>
        </PageForm>
    )
}
export default History
